<div class="alert-bar" *ngIf="showAlert === 3" style="display: flex; align-items: center;">
  <span style="flex: 1; text-align: center;">
    You are using test data, no transactions will be processed. No notifications will be sent.
  </span>
</div>
<main class="auth-container height-full">
  <router-outlet></router-outlet>
</main>
<div class="auth-background"></div>
